// extracted by mini-css-extract-plugin
export default {"topMenu":"TopMenu_topMenu__yQj0R","menuTrigger":"TopMenu_menuTrigger__HHrSv","rightNav":"TopMenu_rightNav__t3dkW","altNav":"TopMenu_altNav__ddG46","closed":"TopMenu_closed__2InTv"};